/**
 * Fantasy Console 0 - Console Controls Component
 */

import { ConsoleStatus } from '../../types'
import styles from './ConsoleControls.module.css'

interface ConsoleControlsProps {
  status: ConsoleStatus
  isPaused: boolean
  isMuted: boolean
  onReload: () => void
  onPauseResume: () => void
  onReset: () => void
  onMuteToggle: () => void
}

export function ConsoleControls({
  status,
  isPaused,
  isMuted,
  onReload,
  onPauseResume,
  onReset,
  onMuteToggle,
}: ConsoleControlsProps) {
  const isDisabled = status === 'loading'

  return (
    <div className={styles.controls}>
      <div className={styles.buttonContainer}>
        <button
          className='btn btn-secondary btn-sm'
          onClick={onReload}
          disabled={isDisabled}
          title='Reload cart (Ctrl + R)'
        >
          <ReloadIcon />
          <span>Run</span>
        </button>

        <button
          className='btn btn-secondary btn-sm'
          onClick={onPauseResume}
          disabled={isDisabled}
          title='Pause/Resume (Ctrl + .)'
        >
          {isPaused ? <PlayIcon /> : <PauseIcon />}
          <span>{isPaused ? 'Resume' : 'Pause'}</span>
        </button>

        {/* NOTE: Doesn't feel necessary */}
        {/* <button
          className="btn btn-secondary btn-sm"
          onClick={onReset}
          disabled={isDisabled}
          title="Reset cart"
        >
          <ResetIcon />
          <span>Reset</span>
        </button> */}

        <button
          className='btn btn-secondary btn-sm'
          onClick={onMuteToggle}
          disabled={isDisabled}
          title={isMuted ? 'Unmute' : 'Mute'}
        >
          {isMuted ? <VolumeOffIcon /> : <VolumeIcon />}
          <span>{isMuted ? 'Unmute' : 'Mute'}</span>
        </button>
      </div>

      <StatusIndicator status={status} />
    </div>
  )
}

function StatusIndicator({ status }: { status: ConsoleStatus }) {
  const statusText = {
    loading: 'Loading...',
    ready: 'Ready',
    running: 'Running',
    paused: 'Paused',
    error: 'Error',
  }

  const statusClass = {
    loading: styles.statusLoading,
    ready: styles.statusReady,
    running: styles.statusRunning,
    paused: styles.statusPaused,
    error: styles.statusError,
  }

  return (
    <div className={`${styles.status} ${statusClass[status]}`}>
      <span className={styles.statusDot} />
      <span>{statusText[status]}</span>
    </div>
  )
}

function ReloadIcon() {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    >
      <path d='M12 7A5 5 0 117 2m0 0v3m0-3h3' />
    </svg>
  )
}

function PlayIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='currentColor'>
      <path d='M3 2v10l9-5z' />
    </svg>
  )
}

function PauseIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='currentColor'>
      <rect x='3' y='2' width='3' height='10' />
      <rect x='8' y='2' width='3' height='10' />
    </svg>
  )
}

function ResetIcon() {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    >
      <rect x='2' y='2' width='10' height='10' rx='1' />
    </svg>
  )
}

function VolumeIcon() {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    >
      <path d='M2 5h2l3-3v10L4 9H2V5z' fill='currentColor' />
      <path d='M10 4.5a3.5 3.5 0 010 5' />
    </svg>
  )
}

function VolumeOffIcon() {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
    >
      <path d='M2 5h2l3-3v10L4 9H2V5z' fill='currentColor' />
      <path d='M10 5l4 4M14 5l-4 4' />
    </svg>
  )
}
